function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import classnames from "classnames";
import PictureComponent from "components/core/picture/picture-component";
import { storyCard } from "./story-card.scss";
import QuoteIconSvg from "./svgs/quote-icon-svg";
const STORY_TYPES = {
    QUOTE: "quote",
    STAT: "stat"
};
const renderImage = (image)=>(image === null || image === void 0 ? void 0 : image.src) ? /*#__PURE__*/ _jsx("div", {
        className: "story-card-image",
        children: /*#__PURE__*/ _jsx(PictureComponent, {
            src: image.src,
            alt: image.alt || "",
            className: "story-card-img",
            pictureClass: "story-card-img-wrapper"
        })
    }) : null;
export const StoryCard = ({ story })=>{
    const { type, backgroundColor, textColor, quoteColor, image, quote, author, role, statValue, statLabel, industry, industryTagColor, industryTagTextColor, ctaText, ctaHref } = story;
    const isStat = type === STORY_TYPES.STAT;
    const cardStyle = {};
    if (backgroundColor) cardStyle.backgroundColor = backgroundColor;
    if (textColor) {
        cardStyle.color = textColor;
        // The decorative quote icon defaults to a subtle light gray on plain white cards; on tinted
        // cards (where a text color is set) it should follow the text color so it stays visible and
        // doesn't blend into the background.
        cardStyle["--quote-icon-color"] = textColor;
    }
    if (quoteColor) cardStyle["--quote-color"] = quoteColor;
    return /*#__PURE__*/ _jsxs("div", {
        style: cardStyle,
        className: `jsx-${storyCard.__hash}` + " " + (classnames("story-card", {
            "is-stat": isStat,
            "is-quote": !isStat
        }) || ""),
        children: [
            isStat ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${storyCard.__hash}` + " " + "story-card-text stat-content",
                        children: [
                            industry && /*#__PURE__*/ _jsx("div", {
                                style: _object_spread({}, industryTagColor && {
                                    backgroundColor: industryTagColor
                                }, industryTagTextColor && {
                                    color: industryTagTextColor
                                }),
                                className: `jsx-${storyCard.__hash}` + " " + "industry-tag",
                                children: industry
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: `jsx-${storyCard.__hash}` + " " + "stat-block",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `jsx-${storyCard.__hash}` + " " + "stat-value",
                                        children: statValue
                                    }),
                                    statLabel && /*#__PURE__*/ _jsx("div", {
                                        className: `jsx-${storyCard.__hash}` + " " + "stat-label",
                                        children: statLabel
                                    })
                                ]
                            }),
                            ctaText ? ctaHref ? /*#__PURE__*/ _jsx("a", {
                                href: ctaHref,
                                className: `jsx-${storyCard.__hash}` + " " + "stat-cta",
                                children: ctaText
                            }) : /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${storyCard.__hash}` + " " + "stat-cta",
                                children: ctaText
                            }) : /*#__PURE__*/ _jsx("span", {
                                "aria-hidden": "true",
                                className: `jsx-${storyCard.__hash}` + " " + "stat-cta stat-cta-placeholder"
                            })
                        ]
                    }),
                    renderImage(image)
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${storyCard.__hash}` + " " + "story-card-text",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `jsx-${storyCard.__hash}` + " " + "quote-icon",
                                children: /*#__PURE__*/ _jsx(QuoteIconSvg, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                dangerouslySetInnerHTML: {
                                    __html: quote
                                },
                                className: `jsx-${storyCard.__hash}` + " " + "quote-text"
                            }),
                            (author || role) && /*#__PURE__*/ _jsxs("div", {
                                className: `jsx-${storyCard.__hash}` + " " + "author-line",
                                children: [
                                    "- ",
                                    author,
                                    role ? `, ${role}` : ""
                                ]
                            })
                        ]
                    }),
                    renderImage(image)
                ]
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: storyCard.__hash,
                children: storyCard
            })
        ]
    });
};
